import React from 'react';

import { ListItem } from '../styles';

import { NodeProps } from './shared';

export function ListItemNode({ children }: NodeProps) {
  return <ListItem>{children}</ListItem>;
}
